import { render, staticRenderFns } from "./oblyk.vue?vue&type=template&id=27909f67"
import script from "./oblyk.vue?vue&type=script&lang=js"
export * from "./oblyk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports